export {
  default as scenicViews,
  ReactComponent as ScenicViews,
} from '@assets/icons/scenic-views.svg'    
